import { twMerge } from "@perceptron/tailwind";
import { clsx, type ClassValue } from "clsx";

/**
 * Combines conditional class names and lets tailwind-merge
 * deduplicate conflicting utility classes.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
